namespace st {
    interface PreventEnterAttributes extends angular.IAttributes {
        stPreventEnter: string;
    }

    let PreventEnter: angular.IDirectiveFactory = ($parse: angular.IParseService) => {
        return {
            restrict: 'A',
            link: function (scope: angular.IScope, el: angular.IAugmentedJQuery, attrib: PreventEnterAttributes) {
                let action = attrib.stPreventEnter ? $parse(attrib.stPreventEnter) : null;
                el.on('keypress', function (e) {
                    if (e.keyCode === 13) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (action) {
                            scope.$apply(action);
                        }
                        return false;
                    }
                });
            }
        };
    };
    PreventEnter.$inject = ['$parse'];

    interface ScopeDataAttributes extends angular.IAttributes {
        type: string;
        stScopeData: string;
    }

    class ScopeDataController {
        static $inject = ['$scope', '$element', '$parse', '$attrs', '$log'];
        constructor(
                $scope: angular.IScope,
                $element: angular.IAugmentedJQuery,
                $parse: angular.IParseService,
                $attrs: ScopeDataAttributes,
                $log: angular.ILogService) {
            let type = $attrs.type;
            let getter: angular.ICompiledExpression;
            let json: string;
            if ((/text\/json/i).test(type)) {
                json = $element.html();
                try {
                    if ($attrs.stScopeData && json) {
                        json = angular.fromJson(json);
                        getter = $parse($attrs.stScopeData);
                        if ($attrs.stScopeData.indexOf('$value') >= 0) {
                            getter($scope, { $value: json });
                        } else if (getter.assign) {
                            getter.assign($scope, json);
                        }
                        $element.remove();
                    }
                } catch (err) {
                    $log.error(`Invalid JSON for st-scope-data="${ $attrs.stScopeData }"`);
                }
            }
        }
    }

    let ScopeData: angular.IDirectiveFactory = () => {
        return {
            restrict: 'A',
            controller: ScopeDataController
        };
    };

    angular.module('st')
    .directive('stPreventEnter', PreventEnter)
    .directive('stScopeData', ScopeData)
    ;
}
